import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface ContractServiceStateIF {
  contractServiceName?: string;
  qrSelectedItems?: string;
}

const initialState = {
  contractServiceName: "",
  qrSelectedItems: "",
} as ContractServiceStateIF;

const contractServiceSlice = createSlice({
  name: "contractService",
  initialState,
  reducers: {
    showContractServiceModal: (
      state,
      action: PayloadAction<{
        contractServiceName: string;
        qrSelectedItems: string;
      }>
    ) => {
      const { contractServiceName, qrSelectedItems } = action.payload;
      state.contractServiceName = contractServiceName;
      state.qrSelectedItems = qrSelectedItems;
    },
  },
});

export const { showContractServiceModal } = contractServiceSlice.actions;

export default contractServiceSlice.reducer;
